import React from 'react';
import { ArrowUp } from 'lucide-react';
import { Monogram } from './Monogram';
import { profileName } from '../data/profile';
import type { LocaleContent } from '../types/profile';
interface SiteFooterProps {
  content: LocaleContent;
}
export function SiteFooter({
  content
}: SiteFooterProps) {
  return <footer className="border-t border-line bg-ivory" data-id="element-131" data-mp="3hheqq31uhrug">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-5 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-132" data-mp="3hglptipkhwk8">
        <div className="flex items-center gap-4" data-id="element-133" data-mp="38h8gqr5cva01">
          <Monogram className="decor" data-id="element-134" data-mp="38ggn3lvbjmce" />
          <div data-id="element-135" data-mp="33i5aj3dn2xqh">
            <p className="text-[16px] font-medium text-charcoal" data-id="element-136" data-mp="33hvm3k88symw">{profileName}</p>
            <p className="mt-0.5 text-[15px] leading-relaxed text-ink-soft" data-id="element-137" data-mp="2yk3smlry94gl">{content.footerNote}</p>
          </div>
        </div>
        <a href="#top" className="no-print group inline-flex items-center gap-2 self-start rounded-full text-[15px] text-ink-soft transition-colors hover:text-charcoal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage/60 sm:self-auto" data-id="element-138" data-mp="11q0mw436amlk">
          {content.actions.backToTop}
          <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5" strokeWidth={1.6} aria-hidden="true" data-id="element-139" data-mp="1ar9jqry50bhz" />
        </a>
      </div>
    </footer>;
}